// src/components/MenuComponent.tsx
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import './MenuComponent.css';

type VisibleOn = 'admin' | 'club' | 'event';
interface MenuItem {
    id: number;
    titleEn: string;
    titleDa: string;
    image: string;
    link: string;
    disabled?: boolean;
    visibleOn?: VisibleOn[]; // <= ny
}

const defaultMenuItems: MenuItem[] = [
    { id: 1, titleEn: 'Events', titleDa: 'Events', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/1.png', link: '/eventmenu', visibleOn: ['admin']},
    { id: 2, titleEn: 'Shifts', titleDa: 'Vagt', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/9.png', link: '/shifts' },
    { id: 4, titleEn: 'ID', titleDa: 'ID', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/5.png', link: '/id' },
    { id: 6, titleEn: 'Visa', titleDa: 'Visum', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/3.png', link: '/visa' },
    { id: 9, titleEn: 'Ticket', titleDa: 'Spisebillet', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/7.png', link: '/ticket' },
    { id: 10, titleEn: 'Meeting Rooms', titleDa: 'Mødelokaler', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/8.png', link: '/admin/MeetingAdmin'},
    { id: 11, titleEn: 'Transport', titleDa: 'Transport', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/10.png', link: '/transportDashboard'},
    { id: 12, titleEn: 'Media', titleDa: 'Media', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/12.png', link: '/admin/mediaapplication'},
    { id: 14, titleEn: 'ID Designer', titleDa: 'ID Designer', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/5.png', link: '/iddesigner' },
    { id: 15, titleEn: 'User Admin', titleDa: 'Bruger Admin', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/useradmin' },
    { id: 16, titleEn: 'Frivilligeliste', titleDa: 'Frivilligeliste', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/friviligeliste', },
    { id: 49, titleEn: 'Drinks admin', titleDa: 'Drinks admin', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/DrinksMenu', },
    { id: 18, titleEn: 'Gruppebeskeder', titleDa: 'Gruppebeskeder', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/gruppebeskeder' },
    { id: 22, titleEn: 'Filesystm', titleDa: 'DokumentSystem', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/events/files' },
    { id: 50, titleEn: 'Experience', titleDa: 'Oplevelser', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/Experience' },

    /*{*//* Trasnport  *//*}*/
    { id: 19, titleEn: 'Ankomst/afrejse', titleDa: 'Ankomst/afrejse', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/transport/overview/1' },
    { id: 20, titleEn: 'Dagsture', titleDa: 'Dagsture', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/transport/daily' },
    { id: 20, titleEn: 'RouteDashboard', titleDa: 'RuteDashboard', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/TransportRouteDashboard' },
    { id: 21, titleEn: 'Settings', titleDa: 'Settings', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/transport/settings' },
    { id: 23, titleEn: 'Settings', titleDa: 'Settings', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/transport-routes' },
    { id: 23, titleEn: 'Bookings', titleDa: 'Bookings', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/admin/transport-route/bookings' },

    /*{*//* IKKE KLAR*//*}*/
    { id: 5, titleEn: 'Hotel', titleDa: 'Hotel', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/2.png', link: '/hotel', disabled: true },
    { id: 7, titleEn: 'Training', titleDa: 'Træning', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/11.png', link: '/training', disabled: true },
    { id: 17, titleEn: 'Vagt stats', titleDa: 'Vagt stats', image: 'https://volunteer.badmintonplayer.dk/Billeder/menu/13.png', link: '/useradmin', disabled: true },


];

interface MenuComponentProps {
    itemsToShow?: number[];
}

const MenuComponent: React.FC<MenuComponentProps> = ({ itemsToShow }) => {
    const { language } = useLanguage();

    const filteredMenuItems = itemsToShow
        ? defaultMenuItems.filter(item => itemsToShow.includes(item.id))
        : defaultMenuItems;

    return (
        <div className="menu-grid">
            {filteredMenuItems.map((item) => {
                const isDisabled = item.disabled;

                return (
                    <div
                        key={item.id}
                        className={`menu-card ${isDisabled ? 'disabled' : ''}`}
                    >
                        {isDisabled ? (
                            <>
                                <img
                                    src={item.image}
                                    alt={language === 'da' ? item.titleDa : item.titleEn}
                                    className="menu-image"
                                />
                                <div className="menu-title">
                                    {language === 'da' ? item.titleDa : item.titleEn}
                                </div>
                            </>
                        ) : (
                            <Link to={item.link}>
                                <img
                                    src={item.image}
                                    alt={language === 'da' ? item.titleDa : item.titleEn}
                                    className="menu-image"
                                />
                                <div className="menu-title">
                                    {language === 'da' ? item.titleDa : item.titleEn}
                                </div>
                            </Link>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default MenuComponent;
